<template>
    <div>
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>My Academic Plan</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        item-value="ay_id"
                        @change="fetchAcademicPlan()"
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        persistent-hint
                        hint="Please select academic year"
                    />
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="renderComponent">
            <child-calendar v-if="renderComponent"></child-calendar>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import child_calendar from "./ChildCalendar.vue";
    export default {
        components: {
            "child-calendar": child_calendar,
        },
        data: () => ({
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: true,
            search: "",
            ay_std_div_list: null,
            sel_ay_data: null,
            academic_planning_list: [],
            show_child_details_card: false,
            renderComponent: false,
            child: null,
        }),

        methods: {
            fetchAcademicPlan() {
                this.academic_planning_list = [];
                this.child = localStorage.getItem("EPS-uid");
                const data = {
                    ay: this.sel_ay_data,
                    child: this.child,
                };
                localStorage.setItem("ay", JSON.stringify(this.sel_ay_data));
                localStorage.setItem("child", JSON.stringify(this.child));

                this.show_child_details_card = false;
                this.renderComponent = false;
                this.loader = true;
                axios
                    .post("/AcademicPlanner/getChildAcademicPlans", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.academic_planning_list = res.data.planning_list;
                            this.show_child_details_card = true;
                            this.renderComponent = true;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.loader = false;
                    })
                    .catch((error) => {
                        //  this.onerror(error);

                        this.loader = false;
                    })
                    .finally(() => {
                        this.loader = false;
                        // this.selected_date=""
                    });
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.loader = true;
            axios
                .post("/commonAPI/get_ay_std_div")
                .then((res) => {
                    this.ay_std_div_list = res.data.data;
                    this.loader = false;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {
                    this.loader = false;
                });
        },
    };
</script>
